import { ShapeBaseAttribute } from './base';

export class SlotAttribute extends ShapeBaseAttribute {
  slotType: 'widget' | 'time' | 'dial' | 'font' | 'dualTime' = 'widget';

  /**
   * 当前显示widget id
   * 注：当等于none时，代表渲染无的widget，即不渲染
   * @memberof SlotAttribute
   */
  widgetIdToDisplay = '';

  /**
   * 是否选择无
   *
   * @memberof SlotAttribute
   */
  includeEmpty = false;
  /**
   * 当可选无时，widget时，对应的图片src
   */
  emptyImageSrc?: string;

  sameEditBox = false;

  resources: {
    /**
     * 容器边框
     */
    editBox?: LayerResourceItem;
  } = {};

  /** 自定义位置是否开启 */
  movable?: boolean;

  /** 自定义位置 */
  positions: { x: number; y: number }[] = [];

  /** 跟随的容器Id */
  slotFollowingId?: string;

  /** 跟随的容器组名 */
  followingGroupName?: string;

  /** 预览自定义位置index */
  curSlotPosition = 0;
}
